<template>
	<div>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			@close="fecharModal"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="avancar"
			:is-confirmar-visivel="true"
			:is-confirmar-desabilitado="!temItemSelecionado"
			nome-botao-confirmar="Avançar"
			:tamanho="modalOptions"
		>
			<template #body>
				<div class="corpo-modal-selecao">
					<primeira-etapa></primeira-etapa>
				</div>
			</template>
		</modal>

		<modal-selecionar-orgao-gerenciador
			:exibir="exibirModalSelecionarOrgaoGerenciador"
			:orgaos="orgaosProcesso"
			titulo-modal="Selecionar Órgão Gerenciador"
			@fechar="fecharModalSelecionarOrgaoGerenciador"
			@buscar-orgaos="buscarOrgaosPrevisaoConsumo"
			@orgao-selecionado="selecionarOrgaoGerenciador"
		>
		</modal-selecionar-orgao-gerenciador>
	</div>
</template>
<script>
import PrimeiraEtapa from '@/views/pages/ata/gerar-ata/com-processo/modal/primeira-etapa/ModalPrimeiraEtapa'
import RoutesNames from '@/core/constants/routes-names'
import { actionTypes, getterTypes } from '@/core/constants'
import { mapGetters, mapState } from 'vuex'
import { Alert } from '@/core/utils'
import mutationTypes from '@/core/constants/mutation-types'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import ModalSelecionarOrgaoGerenciador from './modal-selecionar-orgao-gerenciador/ModalSelecionarOrgaoGerenciador'

export default {
	name: 'modal-ata-com-processo',
	components: {
		ModalSelecionarOrgaoGerenciador,
		PrimeiraEtapa,
	},
	props: {
		exibir: {
			type: Boolean,
		},
	},
	data() {
		return {
			tituloModal: 'Seleção de Processo',
			modalOptions: {
				largura: '900',
				altura: '570',
			},
			orgaosProcesso: [],
			orgaoGerenciadorProcesso: null,
			exibirModalSelecionarOrgaoGerenciador: false,
			paginacaoBuscarOrgaoGerenciador: paginacaoListagem([], 100),
		}
	},
	computed: {
		...mapGetters({
			temItemSelecionado: getterTypes.ITEM_ATA.IS_TEM_ITEM_SELECIONADO,
			itensParaInserirNaAta: getterTypes.ITEM_ATA.ITENS_PARA_INSERIR_NA_ATA,
		}),
		...mapState({
			isUtilizaOrgaoGerenciadorProcesso: (state) => state.parametrosSistema.orgaoGerenciadorProcesso,
			filtros: (state) => state.itemProcesso.filtro,
			isIntegracaoWeblicAtivo: (state) => state.parametrosSistema.isIntegracaoWeblicAtivo,
		}),
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		async avancar() {
			if (!this.temItemSelecionado) {
				new Alert(this.$store).showError('Deve selecionar ao menos um item')
				return
			}

			if (this.isUtilizaOrgaoGerenciadorProcesso || this.processoPossuiOrgaoGestorAta()) await this.salvarAta()
			else await this.abrirModalSelecionarOrgaoGerenciador()
		},
		processoPossuiOrgaoGestorAta() {
			return this.isIntegracaoWeblicAtivo && this.filtros.processo.idOrgaoGestorArp
		},
		async selecionarOrgaoGerenciador(orgaoSelecionado) {
			this.orgaoGerenciadorProcesso = orgaoSelecionado.idOrgao
			await this.salvarAta()
		},
		async buscarOrgaosPrevisaoConsumo(nomeOuSiglaOrgao) {
			const { itens } = await this.$store.dispatch(actionTypes.PROCESSO.BUSCAR_ORGAOS_QUANTIFICARAM_NO_PROCESSO, {
				idProcesso: this.$store.state.itemProcesso.filtro.idProcesso,
				paginacao: this.paginacaoBuscarOrgaoGerenciador,
				nomeOuSigla: nomeOuSiglaOrgao,
			})

			this.orgaosProcesso = itens
		},
		async salvarAta() {
			await this.$store
				.dispatch(actionTypes.ATA.INSERIR_POR_PROCESSO, {
					idProcesso: this.$store.state.itemProcesso.filtro.idProcesso,
					idOrgao: this.orgaoGerenciadorProcesso,
				})
				.then(async (ataResponse) => {
					this.transformarItensParaAdicionarNaAta()
					const payload = this.itensParaInserirNaAta(ataResponse.id)
					await this.salvarItensDaAta(payload)
					await this.gerarDocumentosFornecedores(payload)
				})
		},
		async gerarDocumentosFornecedores(payload) {
			await this.$store
				.dispatch(actionTypes.ATA.DOCUMENTOS_ATA.INSERIR, payload)
				.finally(() => this.redirecionarParaInterna(payload.idAta))
		},
		async salvarItensDaAta(payload) {
			await this.$store.dispatch(actionTypes.ITEM_ATA.INSERIR_ITEM_ATA_COM_PROCESSO, payload)
			this.mostrarNotificacaoSucesso(`Os itens estão sendo salvos na ata.`)
		},
		transformarItensParaAdicionarNaAta() {
			const itens = this.$store.state.itemAta.itensParaAdicionarNaAta.flatMap((item) =>
				item.editais.map((edital) => {
					return {
						idsTipo: item.idsTipos,
						idFornecedor: item.idFornecedor,
						idLotes: edital.lotes,
						idProcesso: item.idProcesso,
						numeroEdital: edital.numeroEdital,
						idItensNaoAdicionados: item.idItensNaoAdicionados,
					}
				}),
			)

			this.$store.commit(mutationTypes.ITEM_ATA.SET_ITENS_ARRAY_PARA_ADICIONAR, itens)
		},
		redirecionarParaInterna(idAta) {
			this.$router.push({
				name: RoutesNames.ATA.ATA_ACESSAR_INFORMACOES_VIEW,
				params: { id: idAta },
			})
		},
		async abrirModalSelecionarOrgaoGerenciador() {
			await this.buscarOrgaosPrevisaoConsumo()
			const possuiSomenteUmOrgao = this.orgaosProcesso.length === 1

			if (possuiSomenteUmOrgao) await this.setarOrgaoParaSalvarAta()
			else this.exibirModalSelecionarOrgaoGerenciador = true
		},
		async setarOrgaoParaSalvarAta() {
			this.orgaoGerenciadorProcesso = this.orgaosProcesso.pop().idOrgao
			await this.salvarAta()
		},
		fecharModalSelecionarOrgaoGerenciador() {
			this.exibirModalSelecionarOrgaoGerenciador = false
		},
	},
}
</script>

<style scoped lang="stylus">
.bg-white
	background-color white

.corpo-modal-selecao
	min-height 70vh
</style>
